<template>
  <div>
    <v-form v-if="loaded"
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="reset"
      @keydown="form.onKeydown($event)"
    >
      <v-alert type="error" v-if="this.form.serial_certificate == null">
        No hay ningún certificado cargado aún.
        <router-link :to="{ name: 'enterprise.certificates.pac.upload' }">Haga clic aquí para cargar uno.</router-link>
      </v-alert>
      <toolbar
        :title="title"
        :loading="form.busy"
        :buttons="buttons"
        @openModalDelete="openModalDelete"
        @update="update"
      />
      <v-layout
        :id="ref"
        class="wrap justify-space-around form-body"
      >
        <v-col
          cols="12"
        >
          <v-text-field
            v-model="form.serial_certificate"
            label="Serial de Certificado"
            :readonly="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="form.issued_date"
            label="Fecha Inicio"
            :readonly="true"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="form.expiration_date"
            label="Fecha Fin"
            :readonly="true"
          />
        </v-col>
      </v-layout>
      <v-dialog
        v-model="dialog"
        max-width="700"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres eliminar este certificado PAC?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="error darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatus"
              @click.prevent="deleteItem()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
    <v-skeleton-loader
        v-else
        max-width="1200px"
        type="text"
    ></v-skeleton-loader>
  </div>
</template>

<script>
import Form from 'vform';
import Toolbar from '~/components/Toolbar';

export default {
  middleware: 'auth',
  components: {
    Toolbar,
  },
  props: {
    id: { default: null },
  },
  data: () => ({
    form: new Form({
      serial_certificate: null,
      issued_date: null,
      expiration_date: null,
    }),
    name: null,
    title: 'Certificado de Cliente PAC',
    toggleStatus: false,
    dialog: false,
    valid: false,
    buttons: [
      {
        id: 'update',
        icon: 'mdi-update',
        name: 'Actualizar',
        event: 'update',
      },
    ],
    apiURL: '/api/enterprises',
    loaded: false,
  }),
  computed: {
    ref() { return this.form.id; },
  },
  async mounted() {
    if (!this.can('actualizar_certificado_empresa')) {
      this.buttons.splice(this.buttons.findIndex(({ id }) => id === 'update'), 1);
    }
    window.axios.get(`${this.apiURL}/${this.id}/certificate/show/PAC`)
    .then((result) => {
      Object.assign(this.form, result.data);
      this.loaded = true;
    });
  },
  methods: {
    openModalDelete() {
      if (this.form.serial_certificate != null) {
        this.dialog = true;
      } else {
         this.$store.dispatch('notifications/show', {
          message: 'No se puede eliminar el registro debido a que no posee un certificado cargado',
          type: 'error',
        });
      }
    },
    update() {
      this.$router.push({ name: 'enterprise.certificates.pac.upload' });
    },
    deleteItem() {
      this.toggleStatus = true;
      const url = `${this.apiURL}/${this.id}/certificate/delete/PAC`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.dialog = false;
        this.toggleStatus = false;
        this.reset();
      });
    },
    cancel() {
      this.$router.go(-1); // someValue
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
